const STORAGE_KEY = 'notifications';

export function normalizeNotification(notification, index) {
    const timestamp = notification.timestamp
        ? new Date(notification.timestamp).toISOString()
        : new Date().toISOString();

    const customer = notification.customer ?? notification.customerNumber ?? null;
    const business = notification.business ?? null;

    return {
        ...notification,
        id: notification.id || `${timestamp}-${index}`,
        timestamp,
        clinicId: notification.clinicId != null ? String(notification.clinicId) : null,
        notificationType: notification.notificationType ?? notification.type ?? null,
        customer: customer != null ? String(customer) : null,
        business: business != null ? String(business) : null,
    };
}

function loadAllFromStorage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(parsed)) {
            return [];
        }
        return parsed.map(normalizeNotification);
    } catch {
        return [];
    }
}

function saveAllToStorage(notifications) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(notifications));
}

export function loadNotifications(clinicId) {
    return loadAllFromStorage()
        .filter((n) => !clinicId || !n.clinicId || String(n.clinicId) === String(clinicId))
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
}

export function deleteNotificationById(id) {
    const next = loadAllFromStorage().filter((n) => n.id !== id);
    saveAllToStorage(next);
    return next;
}

export function clearNotificationsForClinic(clinicId) {
    const next = loadAllFromStorage().filter(
        (n) => !clinicId || !n.clinicId || String(n.clinicId) !== String(clinicId)
    );
    saveAllToStorage(next);
    return next;
}
